import { render, staticRenderFns } from "./ProgressCard.vue?vue&type=template&id=2273e0a2"
import script from "./ProgressCard.vue?vue&type=script&lang=js"
export * from "./ProgressCard.vue?vue&type=script&lang=js"
import style0 from "./ProgressCard.vue?vue&type=style&index=0&id=2273e0a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports